import { useTranslation } from 'react-i18next';

export default function PaymentMethods({ onCreditCardPress, onWireTransferPress }) {
  const { t } = useTranslation(['DonatePage']);

  return (
    <div className={`donate-modal__container`}>
      <div className="donate-modal__payment-method">
        <h2>{t('paymentMethod')}</h2>
        <p>{t('paymentMethodDescription')}</p>

        <button onClick={onCreditCardPress} className="button submit-button">
          {t('byCreditCard')}
        </button>
        <button onClick={onWireTransferPress} className="button submit-button">
          {t('byWireTransfer')}
        </button>
      </div>
    </div>
  );
}
